<template>
  <div class="about-tab">
    <section class="page-head">
      <div class="container center reveal">
        <h1>连接技术与未来</h1>
        <p>扎根浙江，辐射全国。我们不仅仅提供数字化工具，更是您的长期战略转型伙伴。</p>
      </div>
    </section>

    <section class="section intro">
      <div class="container intro-grid">
        <img class="reveal" src="@/assets/about/about-office.jpg" />
        <div class="copy reveal">
          <h2>中鸿云智：数字化转型的驱动力</h2>
          <p>
            中鸿云智（浙江）科技有限公司是一家专注于智慧场域管理领域与数字化政务服务的高新技术企业。
            我们凭借行业洞察与技术创新能力，为政府部门、国企及各类停车场景提供定制化、全链条数字化解决方案。
          </p>
          <p>
            公司成立以来，始终以“赋能政务高效运转，打造智慧出行生态”为使命，整合云计算、大数据、人工智能、物联网等前沿技术。
            截至目前，已为浙江省内 20 余个地市提供数字化转型服务，项目满意度连续三年保持在 95% 以上。
          </p>
          <div class="metrics">
            <div><strong>30+</strong><span>软件著作权</span></div>
            <div><strong>100W+</strong><span>覆盖用户</span></div>
          </div>
        </div>
      </div>
    </section>

    <section class="section soul">
      <div class="container">
        <header class="section-head center reveal">
          <h2>我们的企业灵魂</h2>
          <span class="line"></span>
        </header>
        <div class="soul-grid">
          <article v-for="item in souls" :key="item.title" class="soul-card reveal">
            <div class="icon">
               <img class="icon-img" :src="item.icon" />
            </div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </article>
        </div>
      </div>
    </section>

    <section class="section honor">
      <div class="container">
        <header class="section-head reveal row-head">
          <div>
            <h2>企业荣誉与资质</h2>
            <p>三十余项自主知识产权，多项省级科技创新成果</p>
          </div>
          <!-- <div class="arrows">
            <button type="button">‹</button>
            <button type="button">›</button>
          </div> -->
        </header>
        <div class="award-grid reveal">
          <div class="award-track">
            <article v-for="(item, index) in awardsLoop" :key="`${item.name}-${index}`" class="award-card">
              <img :src="item.img" :alt="item.name" />
              <!-- <span>{{ item.name }}</span> -->
            </article>
          </div>
        </div>
      </div>
    </section>

    <section class="section timeline-wrap">
      <div class="container narrow">
        <header class="section-head center reveal">
          <h2>我们的成长印记</h2>
        </header>
        <div class="timeline">
          <article
            v-for="(item, index) in timeline"
            :key="item.title"
            :class="['timeline-item', { reverse: index % 2 === 1 }, 'reveal']"
          >
            <div class="card">
              <div class="item-head">
                <h4>{{ item.title }}</h4>
                <small>{{ item.tag }}</small>
              </div>
              <p>{{ item.desc }}</p>
            </div>
            <span class="dot"></span>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import eyes from '@/assets/about/eyes.png'
import frontSight from '@/assets/about/frontSight.png'
import heart from '@/assets/about/heart.png'
const certificateContext = require.context('@/assets/about', false, /^\.\/certificate\d+\.png$/)
export default {
  name: 'AboutTab',
  computed: {
    awardsLoop() {
      return [...this.awards, ...this.awards]
    }
  },
  data() {
    return {
      souls: [
        { icon: frontSight, title: '我们的使命', desc: '赋能政务高效运转，打造智慧出行生态，用数字技术推动社会治理现代化。' },
        { icon: eyes, title: '我们的愿景', desc: '成为国内领先的数字化服务提供商，通过持续迭代构建更具温度的城市生态。' },
        { icon: heart, title: '核心价值观', desc: '以客户需求为中心，追求极致，以 1 对 1 深度服务与 7×24 守护建立信任。' }
      ],
      awards: Array.from({ length: 21 }, (_, index) => {
        const num = index + 1
        return {
          name: `企业资质证书 ${num}`,
          img: certificateContext(`./certificate${num}.png`)
        }
      }),
      timeline: [
        { title: '2026年04月', tag: '战略全面升级', desc: '官网全面焕新，完成浙江省内全域政务场景覆盖，累计服务用户突破百万。' },
        { title: '2025年', tag: '深耕技术创新', desc: '“中鸿小门神”指挥中枢获得多项省级科技创新奖项，核心团队规模突破百人。' },
        { title: '成立初期', tag: '扬帆起航', desc: '扎根杭州，核心团队成员由来自互联网大厂及政务信息化领域专家组成。' }
      ]
    }
  }
}
</script>

<style scoped lang="less">
.container {
  width: min(1240px, calc(100% - 48px));
  margin: 0 auto;
}

.narrow {
  width: min(1040px, calc(100% - 48px));
}

.section {
  padding: 62px 0;
}

.center {
  text-align: center;
}

.page-head {
  padding: 68px 0;
  color: #fff;
  background: #2f67ea;
}

.page-head h1 {
  margin: 0 0 8px;
  font-size: clamp(32px, 3.8vw, 48px);
}

.page-head p {
  margin: 0 auto;
  max-width: 740px;
  color: #d8e6ff;
  line-height: 1.7;
}

.intro-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 34px;
  align-items: center;
}

.intro-grid img {
  width: 100%;
  border-radius: 30px;
  border: 1px solid #e3eaf7;
  box-shadow: 0 18px 30px rgba(20, 48, 97, 0.14);
  animation: floatSoft 5.2s ease-in-out infinite;
}

.copy h2 {
  margin: 0 0 12px;
  font-size: clamp(24px, 2.6vw, 34px);
}

.copy p {
  margin: 0 0 12px;
  color: #5f748f;
  line-height: 1.9;
}

.metrics {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.metrics div {
  border-left: 3px solid #2f67ea;
  padding-left: 12px;
}

.metrics strong {
  display: block;
  color: #14386f;
  font-size: 34px;
}

.metrics span {
  color: #7084a3;
  font-size: 13px;
}

.soul {
  background: #081431;
  color: #fff;
}

.section-head h2 {
  margin: 0;
  font-size: clamp(28px, 3vw, 40px);
}

.line {
  margin: 12px auto 0;
  width: 76px;
  height: 3px;
  display: block;
  background: #2f67ea;
}

.soul-grid {
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.soul-card {
  text-align: center;
  border-radius: 16px;
  padding: 22px 18px;
  transition: transform 0.25s ease, box-shadow 0.25s ease, background 0.25s ease;
}

.soul-card .icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 1px solid #1d4fae;
  background: rgba(47, 103, 234, 0.14);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #65a0ff;
  font-weight: 700;
  font-size: 20px;
}
.icon-img{
  width: 32px;
  height: 32px;
}

.soul-card h3 {
  margin: 14px 0 8px;
  font-size: 22px;
}

.soul-card p {
  margin: 0;
  color: #95abd0;
  line-height: 1.8;
}

.soul-card:hover {
  transform: translateY(-6px);
  background: rgba(255, 255, 255, 0.04);
  box-shadow: 0 14px 26px rgba(4, 16, 39, 0.24);
}

.honor {
  background: #fff;
}

.row-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
}

.section-head p {
  margin: 8px 0 0;
  color: #7185a5;
}

.arrows {
  display: flex;
  gap: 8px;
}

.arrows button {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #d8e4f7;
  background: #fff;
  color: #5f7594;
  cursor: pointer;
  transition: all 0.2s ease;
}

.arrows button:hover {
  color: #2f67ea;
  border-color: #bcd2f6;
  transform: translateY(-1px);
}

.award-grid {
  overflow: hidden;
  position: relative;
}

.award-track {
  display: flex;
  gap: 16px;
  width: max-content;
  animation: awardScroll 60s linear infinite;
}

.award-card {
  flex: 0 0 280px;
  border: 1px solid #e4ebf8;
  border-radius: 14px;
  background: #fff;
  padding: 14px;
  text-align: center;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}

.award-card img {
  width: 100%;
  border-radius: 10px;
  transition: transform 0.45s ease;
}

.award-card span {
  margin-top: 10px;
  display: block;
  color: #324966;
}

.award-card:hover {
  transform: translateY(-5px);
  border-color: #c8daf6;
  box-shadow: 0 12px 24px rgba(18, 49, 101, 0.12);
}

.award-card:hover img {
  transform: scale(1.04);
}

.timeline-wrap {
  background: #f4f7fc;
}

.timeline {
  position: relative;
  margin-top: 24px;
  padding: 10px 0;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  transform: translateX(-1px);
  width: 2px;
  background: #aecdff;
}

.timeline-item {
  position: relative;
  display: flex;
  width: 50%;
  padding-right: 34px;
  margin-bottom: 24px;
}

.timeline-item.reverse {
  margin-left: 50%;
  padding-right: 0;
  padding-left: 34px;
}

.timeline-item .dot {
  position: absolute;
  right: -9px;
  top: 20px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #2f67ea;
  border: 4px solid #d9e7ff;
  animation: dotPulse 2s ease-in-out infinite;
}

.timeline-item.reverse .dot {
  right: auto;
  left: -9px;
}

.card {
  background: #fff;
  border: 1px solid #dfe9fa;
  border-radius: 14px;
  padding: 14px;
  transition: transform 0.24s ease, box-shadow 0.24s ease, border-color 0.24s ease;
}

.item-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.item-head h4 {
  margin: 0;
  color: #1a3359;
}

.item-head small {
  color: #2f67ea;
  font-size: 12px;
}

.card p {
  margin: 8px 0 0;
  color: #647a95;
  line-height: 1.7;
}

.timeline-item:hover .card {
  transform: translateY(-4px);
  border-color: #c8daf6;
  box-shadow: 0 12px 22px rgba(20, 51, 101, 0.12);
}

@keyframes floatSoft {
  0% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
  100% { transform: translateY(0); }
}

@keyframes dotPulse {
  0% { box-shadow: 0 0 0 0 rgba(47, 103, 234, 0.35); }
  70% { box-shadow: 0 0 0 10px rgba(47, 103, 234, 0); }
  100% { box-shadow: 0 0 0 0 rgba(47, 103, 234, 0); }
}

@keyframes awardScroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(calc(-50% - 8px)); }
}

@media (max-width: 1024px) {
  .container,
  .narrow {
    width: min(1240px, calc(100% - 36px));
  }

  .intro-grid {
    grid-template-columns: 1fr;
  }

  .soul-grid {
    grid-template-columns: 1fr;
  }

  .award-card {
    flex-basis: 230px;
  }
}

@media (max-width: 768px) {
  .container,
  .narrow {
    width: min(1240px, calc(100% - 24px));
  }

  .page-head p,
  .copy p,
  .soul-card p,
  .card p {
    font-size: 14px;
  }

  .intro-grid img {
    animation: none;
  }

  .timeline::before {
    left: 9px;
  }

  .timeline-item,
  .timeline-item.reverse {
    width: 100%;
    margin-left: 0;
    padding-right: 0;
    padding-left: 30px;
  }

  .timeline-item .dot,
  .timeline-item.reverse .dot {
    left: 0;
    right: auto;
  }

  .award-card {
    flex-basis: 190px;
  }

  .row-head {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
